<template>
	<div class="flex1" style="height:100%">
		<Title :title="'充换电电量（度）'"></Title>
		<echarts v-if="showcdata" :id="'changeElectricityMeasure'" :options="cdata" />
	</div>
</template>

<script>
	import echarts from '../charts/echarts.vue'
	import Title from '../title.vue'
	import {
		dataInterface
	} from '@/api/dataInterfaceApi';
	export default {
		data() {
			return {
				showcdata: false,
				// title:"车辆新增及活跃趋势",
				cdata: {
					legend: {
						right: 'left',
						itemWidth: 10,
						itemHeight: 10,
						textStyle: {
							color: '#fff'
						},
					},
					xAxis: {
						type: 'category',
						boundaryGap: false,
					},
					yAxis: {
						type: 'value',
						splitLine:false
					},
					legendData:[{
							name:"新增数",
							icon: 'roundRect',
						}, {
							name:"活跃数",
							icon: 'roundRect',
					}],
					series: []
				}
			};
		},
		components: {
			echarts,
			Title
		},
		mounted() {
			this.getBattery24hours()
		},
		methods: {
			//获取24小时电次数分布
			getBattery24hours() {
				let params = {
				  "enCode": "per_vehicle-充换电电量",
				  "@VEHICLE_VIN": localStorage.getItem("newVehicleNum") || 'LDP31B967MG929008'
				}
				dataInterface.dataFaceApi(params).then((res) => {
					if(res) {
						let data1 = []
						let data2 = []
						let xAxis = []
						res.forEach(item => {
							xAxis.push(item.cur_date)
							data1.push(item.exchange_elect)
							data2.push(item.charge_elect)
						})
						let series1 = {
							name: '换电',
							type: 'line',
							// stack: 'Total',
							smooth: true,
							itemStyle: {
								normal: {
									color: '#1CD3F3'
								}
							},
							showSymbol: false,
							areaStyle: {
								opacity: 0.8,
								color: 'rgba(28, 211, 243, .2)'
							},
						}
						let series2 = {
							name: '充电',
							type: 'line',
							// stack: 'Total',
							smooth: true,
							itemStyle: {
								normal: {
									color: '#7C6AF2'
								}
							},
							showSymbol: false,
							areaStyle: {
								opacity: 0.8,
								color: 'rgba(124, 106, 242, .2)'
							},
						}
						this.cdata.xAxis.data = xAxis
						series1.data = data1
						this.cdata.series.push(series1)
						series2.data = data2
						this.cdata.series.push(series2)
						this.showcdata = true
					}
				}).catch((err) => {
					console.log(err);
				  });
			}
		}
	};
</script>


<style lang="scss" scoped>
@import './comm.scss';
</style>
